import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { IoClose } from "react-icons/io5";
import { imgBaseUrl } from "../../Const";
import { onError } from "../CommonFun";

export default function ImagesModal({ show, handleHide, propertyImgsmdl, fileNameThreeD, fileNameTwoD, id }) {
    const swiperRef = useRef(null);
    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.swiper.slideTo(id, 0); // Jump to the slide
        }
    }, [id]);
    return (
        <Modal size="lg" className="image-modal modal-overlay" aria-labelledby="contained-modal-title-vcenter" show={show} centered>
            <button className="close-btn" onClick={handleHide}>
                <IoClose />
            </button>
            <Modal.Body>
                {/* //check all calling api and resolving multi time api calling  and   */}
                <div className="accordion-swiper-modal">
                    {propertyImgsmdl?.length > 1 || fileNameThreeD?.length > 1 || fileNameTwoD?.length > 1 ? (
                        <Swiper ref={swiperRef} modules={[Navigation]} spaceBetween={20} slidesPerView={1} navigation loop={false} className="swiper-container">
                            {propertyImgsmdl &&
                                propertyImgsmdl.length > 0 &&
                                propertyImgsmdl
                                    .filter((img) => !img.needHide)
                                    .sort((a, b) => {
                                        if (a.isCover) return -1;
                                        if (b.isCover) return 1;
                                        return a.orderRank - b.orderRank;
                                    })
                                    .map((slide, index) => (
                                        <SwiperSlide key={index}>
                                            <img src={imgBaseUrl + slide.path} alt={`Slide ${index + 1}`} className="img-slider" loading="lazy" onError={onError}/>
                                            <div className="media_counter pt-5">
                                                <p>{slide.title}</p>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                            {fileNameThreeD &&
                                fileNameThreeD.length > 0 &&
                                fileNameThreeD.map((slide, index) => (
                                    <SwiperSlide key={index}>
                                        <img src={imgBaseUrl + slide.threeDPath} alt={`Slide ${index + 1}`} className="img-slider"loading="lazy"onError={onError} />
                                        <div className="media_counter pt-5">
                                            <p>{slide.label}</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            {fileNameTwoD &&
                                fileNameTwoD.length > 0 &&
                                fileNameTwoD.map((slide, index) => (
                                    <SwiperSlide key={index}>
                                        <img src={imgBaseUrl + slide.twoDPath} alt={`Slide ${index + 1}`} className="img-slider"loading="lazy"onError={onError} />
                                        <div className="media_counter pt-5">
                                            <p>{slide.label}</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                        </Swiper>
                    ) : (
                        <Swiper  ref={swiperRef} spaceBetween={20} slidesPerView={1} loop={false} className="swiper-container">
                            {propertyImgsmdl &&
                                propertyImgsmdl.length > 0 &&
                                propertyImgsmdl
                                    .filter((img) => !img.needHide)
                                    .sort((a, b) => {
                                        if (a.isCover) return -1;
                                        if (b.isCover) return 1;
                                        return a.orderRank - b.orderRank;
                                    })
                                    .map((slide, index) => (
                                        <SwiperSlide key={index}>
                                            <img src={imgBaseUrl + slide.path} alt={`Slide ${index + 1}`} className="img-slider" loading="lazy" onError={onError}/>
                                            <div className="media_counter pt-5">
                                                <p>{slide.title}</p>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                            {fileNameThreeD &&
                                fileNameThreeD.length > 0 &&
                                fileNameThreeD.map((slide, index) => (
                                    <SwiperSlide key={index}>
                                        <img src={imgBaseUrl + slide.threeDPath} alt={`Slide ${index + 1}`} className="img-slider" loading="lazy"onError={onError}/>
                                        <div className="media_counter pt-5">
                                            <p>{slide.label}</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            {fileNameTwoD &&
                                fileNameTwoD.length > 0 &&
                                fileNameTwoD.map((slide, index) => (
                                    <SwiperSlide key={index}>
                                        <img src={imgBaseUrl + slide.twoDPath} alt={`Slide ${index + 1}`} className="img-slider"loading="lazy"onError={onError} />
                                        <div className="media_counter pt-5">
                                            <p>{slide.label}</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                        </Swiper>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
}
